/**
 * User instructions for password creation 
 */
export enum PasswordLengthRules {
  Min = 10,
  Max = 100
}